import React, {useRef} from 'react';
import { Button } from 'react-bootstrap';

const FileUploader = ({onFileSelectSuccess, onFileSelectError, children, disabled = false}) => {
  const fileInput = useRef(null);

  const handleFileInput = async (e) => {

    // handle validations
    const files = e.target.files;
    for (let i = 0; i < files.length; i++) {
      await onFileSelectSuccess(files[i]);
    }

    // files.map(file => {
    //   onFileSelectSuccess(file);
    // })
    // if (file.size > 1024) {
    //   onFileSelectError({ error: "File size cannot exceed more than 1MB" });
    // } else  {
      // onFileSelectSuccess(file);
    // }
  }

  return (
    <div className="file-uploader">
      <input
        accept="*"
        ref={fileInput}
        style={{ display: 'none' }}
        type="file"
        onChange={handleFileInput}
        multiple
      />
      <Button
        disabled={disabled}
        variant="info"
        onClick={() => fileInput.current && fileInput.current.click()}
      >
        {children}
      </Button>
    </div>
  );
}

export default FileUploader;